import React from 'react'
import PropTypes from 'prop-types'
import * as S from './CatalogGoodItem.styled' // eslint-disable-next-line import/no-cycle
import CatalogGoodInfo from './CatalogGoodInfo/CatalogGoodInfo'
import CatalogGoodImageBlock from './CatalogGoodImageBlock/CatalogGoodImageBlock'
import { getGoodUrl } from '@services/catalogService'
import { ICatalogGoodBase } from '@entities/goods/contract'

interface CatalogGoodItemProps {
    children: ICatalogGoodBase
    groupId?: number
    isRequiredNormalPrice: boolean
}

const CatalogGoodItem = ({ children, groupId, isRequiredNormalPrice }: CatalogGoodItemProps) => {
    const linkGoodCart = getGoodUrl(children.webData, groupId)
    return (
        <S.Container
            data-good-is-available-delivery-by-erecipe={children.isAvailableDeliveryByErecipe}
            data-good-id={children.webData.goodId}>
            <CatalogGoodImageBlock
                id={children.webData.goodId}
                linkGoodCart={linkGoodCart}
                hasImage={children.webData.hasImage}
                isCold={children.isCold}
                isStrictlyByPrescription={children.isStrictlyByPrescription}
                deliveryStatus={children.deliveryStatus}
                isAvailableDeliveryByErecipe={children.isAvailableDeliveryByErecipe}
            />
            <CatalogGoodInfo isRequiredNormalPrice={isRequiredNormalPrice} linkGoodCart={linkGoodCart}>
                {children}
            </CatalogGoodInfo>
        </S.Container>
    )
}

CatalogGoodItem.propTypes = {
    children: PropTypes.object,
    isRequiredNormalPrice: PropTypes.bool,
    groupId: PropTypes.number
}

CatalogGoodItem.defaultProps = {
    isRequiredNormalPrice: false
}

export default CatalogGoodItem
